import { render, staticRenderFns } from "./AdminTestimonyEditPage.vue?vue&type=template&id=4ff52ced"
import script from "./AdminTestimonyEditPage.vue?vue&type=script&lang=js"
export * from "./AdminTestimonyEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports